import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Row, Col, ButtonGroup, Button } from 'reactstrap';
import { PageTitle, CoursesCalendar } from '../../../components';

import './CoursesPlanning.css';
import { loadCourses, loadSubjects } from '../../../redux/modules';

import { mdiCastEducation } from '@mdi/js';

const CoursesPlanning = props => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const [groupBy, setGroupBy] = useState('groupId');
    const { subjects } = useSelector(state => state.courses);

    const {
        courses,
        hasLoadingError,
        loadingErrorMessage
    } = useSelector(state => state.courses);

    useEffect(() => {
        dispatch(loadSubjects());
        dispatch(loadCourses());
    }, [])

    return (
        <div className="CoursesPlanning">
            <PageTitle icon={mdiCastEducation} title={t('planning.courses_planning')} />
            <Row className="justify-content-md-center">
                <Col md="auto">
                    <ButtonGroup>
                        <Button onClick={() => setGroupBy('groupId')} color={groupBy === 'groupId' ? 'primary' : 'dark'} className="text-light">
                            {t('planning.group_by_groups')}
                        </Button>
                        <Button onClick={() => setGroupBy('teacherId')} color={groupBy === 'teacherId' ? 'primary' : 'dark'} className="text-light">
                            {t('planning.group_by_teachers')}
                        </Button>
                    </ButtonGroup>
                </Col>
            </Row>
            { courses && (
                <CoursesCalendar
                    courses={courses}
                    subjects={subjects}
                    groupBy={groupBy}
                    defaultView="day"
                    onlyAgenda={false}
                />
            )}
        </div>
    );
}

export default CoursesPlanning;
